/* eslint-disable react/require-default-props */
import React, { useRef, useEffect } from 'react';
import { translate } from '@utils/i18n';
import { InlineEdit } from '@components/v2/InlineEdit';
/**
 * Component for displaying and editing manager notes using InlineEdit.
 *
 * Saves on blur AND on unmount. The unmount save is needed because the
 * IssueDetailBlade unmounts its entire tree (via selectedIssueId → null)
 * before the browser's focus-change default behavior fires blur on the
 * contenteditable. Without the unmount save the typed note would be lost.
 */
export default function ManagerNote({ note, onNoteChange, disabled = false, title = translate('manager_note', { namespace: 'features.iim_review.issue_card' }) }) {
    // Track live contenteditable text; null means "nothing unsaved"
    const currentTextRef = useRef(null);
    // Stable refs so the unmount cleanup always reads the latest values
    const noteRef = useRef(note !== null && note !== void 0 ? note : '');
    const onNoteChangeRef = useRef(onNoteChange);
    noteRef.current = note !== null && note !== void 0 ? note : '';
    onNoteChangeRef.current = onNoteChange;
    // Save any unsaved changes when the component unmounts.
    // Empty deps → cleanup runs only on true unmount, not on re-renders
    // from optimistic updates that change the `note` prop.
    useEffect(() => {
        return () => {
            const pending = currentTextRef.current;
            if (pending !== null && pending !== (noteRef.current || '')) {
                onNoteChangeRef.current(pending);
            }
        };
    }, []);
    const handleInput = (e) => {
        currentTextRef.current = e.currentTarget.textContent || '';
    };
    const handleNoteChange = (e) => {
        const newNote = e.currentTarget.textContent || '';
        currentTextRef.current = null; // Mark as saved — prevents duplicate on unmount
        if (newNote !== (note || '')) {
            onNoteChange(newNote);
        }
    };
    return (React.createElement("div", { className: "issue-card__manager-note" },
        React.createElement("label", { htmlFor: "manager-note", className: "issue-card__manager-note-label" }, title),
        React.createElement(InlineEdit, { id: "manager-note", className: "issue-card__manager-note-input", disableEdit: disabled, placeholder: translate('add_manager_note', { namespace: 'features.iim_review.issue_card' }), onBlur: handleNoteChange, onInput: handleInput }, note)));
}
